export enum RoutePage {
  IndexPage = "",
  InspectionList = "inspection-list",
  InspectionReportList = "inspection-report-list",
  Inspection = "inspection",
  InspectionDataManagement = "inspection-data-management",
  InspectionReport = "inspection-report",
  Settings = "settings",
  AnalyticsPowerBiReport = "analytics/powerbi-report",
  LicenseAgreement = "license-agreement",
  AccessPage = "access-page",
  NotFound = "403",
  Login = "login",
  CancelLogin = "cancel-login",
  Logout = "logout",
  AuthenticationFailure = "auth-fail"
}

export enum RouteAssetModule {
  Blueprints = "blueprints",
  LiveAssets = "live-assets",
}

export enum RouteSettings {
  Subject = "subject",
  ReportTemplateList = "report-template-list",
  OfflineReportTemplate = "offline-report-template",
  Tags = "tags",
  Title = "title",
  Mark = "mark",
  TenantConfig = "tenant-config",
  IplexOne = "iplex-one"
}

export function parseUrlToRoutePage(url: string): RoutePage {
  const splittedUrl = url.split("/");
  const primaryRoute = splittedUrl[1] || "";
  const routeKey = Object.values(RoutePage).find((value) => value === primaryRoute);
  return routeKey || RoutePage.InspectionList;
}
